const route = {
    path: '/releaseRequests',
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "release" */ '../../components/views/releaseRequests/requests.vue'),
            }
        },
        {
            path: ':type/:id',
            components: {
                default:
                    () => import(/* webpackChunkName: "release" */ '../../components/views/releaseRequests/request.vue'),
            }
        },
    ],
}

module.exports = route;